/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */

import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import GenericModal from "../../Modal/GenericModal";
import { Vocabulary } from "../../Utils/Vocabulary";
import { ClientData } from "./Clients";
import { SyntheticEvent, useContext, useEffect, useState } from "react";
import { updateData } from "../../Services/updateData";
import { postData } from "../../Services/postData";
import { urlEnum } from "../../Utils/urlEnum";
import { isMobile, disableTostifyConfig } from "../../Utils/utils";
import moment from "moment";
import DinamicTabs from "../DinamicTabs";
import { MainTableProps } from "../MainTable";
import { romanianCities } from "../../Utils/Constants";
import { CacheContext } from "../../Context/cacheContext";
import ClientDocumentsPanel from "./ClientDocumentsPanel";
import ClientVehiclesPanel from "./ClientVehiclesPanel";
import ClientDropdown, { ClientData as ClientDropdownData } from "../Generic/ClientDropdown";

type ClientProps = {
  open: boolean;
  title: string;
  editedClient?: ClientData | null;
  sourceLeadId?: number;
  onClose: (shouldRefetch?: boolean) => void;
};

const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const initialState: ClientData = {
  companyName: "",
  lastName: "",
  firstName: "",
  email: "",
  phone: "",
  CNP: "",
  series: "",
  number: "",
  CUI: "",
  nrRegCom: "",
  street: "",
  city: "",
  country: "",
  isLegalPerson: false,
  createdByName: "",
};

function TabPanel(props: MainTableProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        backgroundColor: "#ebebeb49",
        padding: 10,
        borderRadius: "0px 0px 10px 10px",
      }}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography component={"span"} variant={"body2"}>
            {children}
          </Typography>
        </Box>
      )}
    </div>
  );
}

export default function Client(props: ClientProps) {
  const {
    open,
    title,
    editedClient,
    sourceLeadId,
    onClose,
  } = props;
  const [value, setValue] = useState(0);
  const [data, setData] = useState<ClientData>(initialState);
  const [countries, setCountries] = useState<any>();
  const [cities, setCities] = useState<any>();
  const [mode, setMode] = useState<"new" | "existing">("new");
  const [selectedExistingClient, setSelectedExistingClient] = useState<any>(null);
  const [linkLoading, setLinkLoading] = useState(false);
  const cacheContext = useContext(CacheContext);

  const isLinkMode = !!sourceLeadId && !editedClient?.id;

  useEffect(() => {
    if (editedClient) {
      setData(editedClient);
    } else setData(initialState);
    setMode("new");
    setSelectedExistingClient(null);
  }, [editedClient, open]);

  async function linkExistingClient() {
    if (!selectedExistingClient || !sourceLeadId) return;
    setLinkLoading(true);
    try {
      await updateData(
        `${urlEnum.clientMessages}/${sourceLeadId}${disableTostifyConfig}`,
        { client_id: selectedExistingClient.id }
      );
      onClose(true);
    } finally {
      setLinkLoading(false);
    }
  }

  /**
   *
   * @param event
   */
  function handleChangeTextFields(event: any) {
    setData({
      ...data,
      [event.target.name]:
        event.target.name != "email"
          ? capitalize(event.target.value)
          : event.target.value,
    });
  }
  /**
   *
   */
  useEffect(() => {
    getCountriesAPI();
  }, []);

  /**
   * Initialize countries to Romania only and cities to all Romanian cities
   */
  const getCountriesAPI = () => {
    // Set countries to Romania only
    setCountries([{ country: "Romania", cities: romanianCities }]);
    // Set all cities from the constant
    setCities(romanianCities);
  };

  /**
   * Get info from ANAF
   */
  function getInfoFromANAF() {
    if (data.CUI === null || data.CUI === "") return;
    const cui = data.CUI.replace("RO", "");
    const info = [
      {
        cui: cui,
        data: moment().format("YYYY-MM-DD"),
      },
    ];

    postData(`${urlEnum.clients}/anaf`, info)
      .then((response) => {
        if (response.data.company.length === 0) return;
        setData({
          ...data,
          companyName: response.data.company[0]?.date_generale?.denumire,
          street: `${response.data.company[0].adresa_domiciliu_fiscal?.ddenumire_Strada}, Nr. ${response.data.company[0]?.adresa_domiciliu_fiscal?.dnumar_Strada}`,
          city: response.data.company[0].adresa_domiciliu_fiscal
            ?.ddenumire_Judet,
          CUI: response.data.company[0].date_generale?.cui,
          nrRegCom: response.data.company[0].date_generale?.nrRegCom,
          country: "Romania",
        });
      })
      .catch((error) => {
        //
      });
  }

  /**
   *
   * @param page
   * @param perPage
   * @param search
   */
  /**
   * Save client
   */
  function saveClient() {
    if (editedClient?.id) {
      updateData(`${urlEnum.clients}/${editedClient.id}`, data)
        .then(() => {
          setData(initialState);
          onClose(true);
        })
        .catch(() => {
          setData(initialState);
          onClose(false);
        });
    } else {
      postData(urlEnum.clients, { ...data, sourceLeadId })
        .then((response) => {
          if (sourceLeadId) {
            const clientId = response?.data?.client_id;
            if (clientId) {
              updateData(
                `${urlEnum.clientMessages}/${sourceLeadId}${disableTostifyConfig}`,
                { client_id: clientId },
              );
            }
          }
          setData(initialState);
          onClose(true);
        })
        .catch(() => {
          setData(initialState);
          onClose(false);
        });
    }
  }

  return (
    <>
      <GenericModal
        open={open}
        onClose={() => {
          onClose(false);
          setData(initialState);
          setValue(0);
        }}
        title={title}
        fullScreenOnMobile={true}
      >
        {isLinkMode && (
          <Grid container spacing={2} style={{ marginBottom: 16 }}>
            <Grid item xs={6}>
              <Box
                onClick={() => setMode("new")}
                style={{
                  border: `2px solid ${mode === "new" ? "#FF6B1A" : "#e5e7eb"}`,
                  borderRadius: 8,
                  padding: "14px 12px",
                  cursor: "pointer",
                  textAlign: "center",
                  background: mode === "new" ? "#fff7f0" : "#fafafa",
                  transition: "all 0.15s",
                }}
              >
                <Typography variant="body2" style={{ fontWeight: 700, color: mode === "new" ? "#FF6B1A" : "#374151" }}>
                  + {Vocabulary.newClient}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Creează un client nou
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                onClick={() => setMode("existing")}
                style={{
                  border: `2px solid ${mode === "existing" ? "#FF6B1A" : "#e5e7eb"}`,
                  borderRadius: 8,
                  padding: "14px 12px",
                  cursor: "pointer",
                  textAlign: "center",
                  background: mode === "existing" ? "#fff7f0" : "#fafafa",
                  transition: "all 0.15s",
                }}
              >
                <Typography variant="body2" style={{ fontWeight: 700, color: mode === "existing" ? "#FF6B1A" : "#374151" }}>
                  🔗 {Vocabulary.linkExistingClient}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Asociază un client existent
                </Typography>
              </Box>
            </Grid>
          </Grid>
        )}

        {isLinkMode && mode === "existing" ? (
          <Box>
            <ClientDropdown
              value={selectedExistingClient}
              onChange={(val: ClientDropdownData | null) => setSelectedExistingClient(val)}
              label={Vocabulary.searchExistingClient}
            />
            <Grid container spacing={2} style={{ marginTop: 8 }}>
              <Grid item xs={6}>
                <Button fullWidth variant="contained" color="secondary" onClick={() => onClose(false)}>
                  {Vocabulary.cancel}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  disabled={!selectedExistingClient || linkLoading}
                  style={{ color: "#fff" }}
                  onClick={linkExistingClient}
                >
                  {Vocabulary.linkClient}
                </Button>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <>
        <DinamicTabs
          name={""}
          labels={
            editedClient?.id
              ? [Vocabulary.info, Vocabulary.documents, Vocabulary.vehicles]
              : [Vocabulary.info]
          }
          handleChangeTab={(_e: any, newValue: number) => {
            setValue(newValue);
          }}
          openModalWindow={() => { /* handled inside ClientDocumentsPanel */ }}
          value={value}
        />
        <TabPanel value={value} index={0}>
          <ValidatorForm onSubmit={saveClient}>
            {editedClient && data.createdByName && (
              <Box
                sx={{
                  mb: 2,
                  p: 1.5,
                  borderRadius: 1,
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  <strong>{Vocabulary.createdBy}:</strong> {data.createdByName}
                </Typography>
              </Box>
            )}
            <Grid
              container
              spacing={isMobile() ? 1 : 2}
              style={{
                paddingBottom: 15,
                zIndex: 100,
                marginTop: 5,
                marginBottom: 10,
              }}
            >
              <Grid style={{ display: "flex" }} item lg={12} md={12} xs={12}>
                <Checkbox
                  onClick={(event: any) =>
                    setData({ ...data, isLegalPerson: event.target.checked })
                  }
                  checked={data.isLegalPerson}
                ></Checkbox>
                <div style={{ marginTop: 11 }}>{Vocabulary.isLegalPerson}</div>
              </Grid>

              {data.isLegalPerson ? (
                <Grid item md={12} xs={12}>
                  <TextValidator
                    size="small"
                    name="companyName"
                    label={Vocabulary.companyName}
                    fullWidth
                    validators={["required"]}
                    errorMessages={[Vocabulary.requiredField]}
                    value={data.companyName}
                    onChange={handleChangeTextFields}
                  />
                </Grid>
              ) : null}
              <Grid item md={6} xs={12}>
                <TextValidator
                  size="small"
                  name="lastName"
                  label={Vocabulary.lastName}
                  fullWidth
                  validators={["required"]}
                  errorMessages={[Vocabulary.requiredField]}
                  value={data.lastName}
                  onChange={handleChangeTextFields}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextValidator
                  size="small"
                  name="firstName"
                  label={Vocabulary.firstName}
                  fullWidth
                  validators={["required"]}
                  errorMessages={[Vocabulary.requiredField]}
                  value={data.firstName}
                  onChange={handleChangeTextFields}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextValidator
                  size="small"
                  name="email"
                  label={Vocabulary.email}
                  fullWidth
                  validators={["required", "isEmail"]}
                  errorMessages={[
                    Vocabulary.requiredField,
                    Vocabulary.incorrectEmail,
                  ]}
                  value={data.email}
                  onChange={handleChangeTextFields}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextValidator
                  size="small"
                  name="phone"
                  label={Vocabulary.phone}
                  fullWidth
                  validators={["required"]}
                  errorMessages={[Vocabulary.requiredField]}
                  value={data.phone}
                  onChange={handleChangeTextFields}
                />
              </Grid>
              {!data.isLegalPerson ? (
                <>
                  <Grid item md={6} xs={12}>
                    <TextValidator
                      size="small"
                      name="series"
                      label={Vocabulary.series}
                      fullWidth
                      validators={["required"]}
                      errorMessages={[Vocabulary.requiredField]}
                      value={data.series}
                      onChange={handleChangeTextFields}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <TextValidator
                      size="small"
                      name="number"
                      label={Vocabulary.number}
                      fullWidth
                      validators={["required"]}
                      errorMessages={[Vocabulary.requiredField]}
                      value={data.number}
                      onChange={handleChangeTextFields}
                    />
                  </Grid>
                </>
              ) : null}
              <Grid item md={6} xs={12}>
                {data.isLegalPerson ? (
                  <TextValidator
                    size="small"
                    name="CUI"
                    label={Vocabulary.CUI}
                    fullWidth
                    validators={[
                      "required",
                      "matchRegexp:^([a-zA-Z]{2})?[0-9]{6,8}$"
                    ]}
                    errorMessages={[
                      Vocabulary.requiredField,
                      Vocabulary.invalidCUI,
                    ]}
                    value={data.CUI}
                    onChange={handleChangeTextFields}
                    onBlur={getInfoFromANAF}
                  />
                ) : (
                  <TextValidator
                    size="small"
                    name="CNP"
                    label="CNP"
                    fullWidth
                    validators={[
                      "required",
                      "matchRegexp:^[1,2,5,6,7,8].*",
                      "matchRegexp:^.{13}$",
                      // "matchRegexp:^.{3}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])",
                    ]}
                    errorMessages={[
                      Vocabulary.requiredField,
                      Vocabulary.firstNumberCNP,
                      Vocabulary.numberCNP,
                      // Vocabulary.invalidCNP,
                    ]}
                    value={data.CNP}
                    onChange={handleChangeTextFields}
                  />
                )}
              </Grid>
              {data.isLegalPerson ? (
                <Grid item md={6} xs={12}>
                  <TextValidator
                    size="small"
                    name="nrRegCom"
                    label={Vocabulary.nrRegCom}
                    fullWidth
                    validators={["required"]}
                    errorMessages={[Vocabulary.requiredField]}
                    value={data.nrRegCom}
                    onChange={handleChangeTextFields}
                  />
                </Grid>
              ) : null}
              <Grid item md={6} xs={12}>
                {countries && (
                  <Autocomplete
                    id="country"
                    freeSolo={false}
                    disablePortal
                    getOptionLabel={(option: any) =>
                      option.country ? option?.country : option
                    }
                    size="small"
                    options={countries ? countries : []}
                    onChange={(
                      event: SyntheticEvent<Element, Event>,
                      newValue: any,
                    ) => {
                      if (newValue) {
                        const value = Object.assign(newValue).country;
                        setData({
                          ...data,
                          city: null,
                          country: value,
                        });
                      } else {
                        setData({
                          ...data,
                          city: null,
                          country: null,
                        });
                      }
                    }}
                    sx={{ width: "100%" }}
                    value={data.country ? data?.country : null}
                    ListboxProps={{ style: { maxHeight: 280 } }}
                    isOptionEqualToValue={(option: any, value) =>
                      option?.country
                        ? option?.country.toLowerCase() === value.toLowerCase()
                        : option.toLowerCase() === value.toLowerCase()
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={Vocabulary.country}
                        required
                        variant="outlined"
                        size="small"
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item md={6} xs={12}>
                {countries && (
                  <Autocomplete
                    id="city"
                    freeSolo={false}
                    disablePortal
                    getOptionLabel={(option: any) => option}
                    size="small"
                    options={cities ? cities : []}
                    onChange={(
                      event: SyntheticEvent<Element, Event>,
                      newValue: string | null,
                    ) => {
                      setData({
                        ...data,
                        city: newValue,
                      });
                      //  setCities(newValue['cities' as keyof typeof newValue]);
                    }}
                    sx={{ width: "100%" }}
                    ListboxProps={{ style: { maxHeight: 280 } }}
                    value={data.city ? data?.city : null}
                    isOptionEqualToValue={(option, value) =>
                      option.toLowerCase() == value.toLowerCase()
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        label={Vocabulary.city}
                        variant="outlined"
                        size="small"
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item md={6} xs={12}>
                <TextValidator
                  size="small"
                  name="street"
                  label={Vocabulary.street}
                  fullWidth
                  validators={["required"]}
                  errorMessages={[Vocabulary.requiredField]}
                  value={data.street}
                  onChange={handleChangeTextFields}
                />
              </Grid>
            </Grid>
            <Grid container spacing={isMobile() ? 1 : 4}>
              <Grid item md={6} xs={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => onClose(false)}
                  fullWidth
                >
                  {Vocabulary.cancel}
                </Button>
              </Grid>
              <Grid item md={6} xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  type="submit"
                  style={{ color: "white" }}
                >
                  {Vocabulary.save}
                </Button>
              </Grid>
            </Grid>
          </ValidatorForm>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ClientDocumentsPanel editedClient={editedClient} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          {editedClient?.id && (
            <ClientVehiclesPanel clientId={editedClient.id} />
          )}
        </TabPanel>
          </>
        )}
      </GenericModal>
    </>
  );
}
